<core-generic-table 
    [dataInput]="log()" 
    [endpoint]="endpoint" 
    [listTitle]="'auditLog.title' | translate"
    [columns]="columns" 
    [modalTabs]="modalFields()" 
    [actions]="[]" 
    [globalActions]="globalActions"
    [showFilter]="false" 
    [showSelection]="false" 
    [showActions]="true" 
    [showCreateButton]="false" 
    [enablePagination]="true"
    [customActions]="customActions"
    [modelFactory]="auditLogModelFactory" class="o-layout__section" />

<core-generic-modal 
    [isOpen]="!!auditLogModalState()" 
    [title]="'auditLog.modal' | translate"
    [mode]="modalmodes.VIEW" 
    [data]="model()" 
    (close)="onCloseModal()"
    [customTemplate]="auditLogChangesTemplate">
</core-generic-modal>

<ng-template #auditLogChangesTemplate>
    @if (model()) {
        <core-generic-table 
            [columns]="columnsLogs" 
            [actions]="[]"
            [dataInput]="model().changes" />
    }
</ng-template>